import { get, put } from "../client";

export interface LinkhubSettings {
  socialGiz: {
    instagram: string | null;
    tiktok: string | null;
    whatsapp: string | null;
  };
  socialRiw: {
    instagram: string | null;
    tiktok: string | null;
    whatsapp: string | null;
  };
  links: {
    official_website: string | null;
    tiket_com: string | null;
    booking_rombongan: string | null;
    rabbit_goes_to_school: string | null;
  };
}

interface LinkhubResponse {
  success: boolean;
  data: any;
}

function rowsToMap(rows: any): Record<string, string | null> {
  if (!Array.isArray(rows)) {
    return {};
  }

  return rows.reduce<Record<string, string | null>>((acc, row) => {
    const key = String(row?.key || "");
    if (!key) return acc;
    acc[key] = row?.value ?? null;
    return acc;
  }, {});
}

function normalizeLinkhubSettings(payload: any): LinkhubSettings {
  const socialGiz = rowsToMap(payload?.socialGiz);
  const socialRiw = rowsToMap(payload?.socialRiw);
  const links = rowsToMap(payload?.links);

  return {
    socialGiz: {
      instagram: socialGiz.instagram ?? null,
      tiktok: socialGiz.tiktok ?? null,
      whatsapp: socialGiz.whatsapp ?? null,
    },
    socialRiw: {
      instagram: socialRiw.instagram ?? null,
      tiktok: socialRiw.tiktok ?? null,
      whatsapp: socialRiw.whatsapp ?? null,
    },
    links: {
      official_website: links.official_website ?? null,
      tiket_com: links.tiket_com ?? null,
      booking_rombongan: links.booking_rombongan ?? null,
      rabbit_goes_to_school: links.rabbit_goes_to_school ?? null,
    },
  };
}

export async function getLinkhubSettings(): Promise<LinkhubSettings> {
  const response = await get<LinkhubResponse>("/admin/linkhub");
  return normalizeLinkhubSettings(response.data);
}

export async function updateLinkhubSettings(
  data: Partial<LinkhubSettings>
): Promise<void> {
  await put("/admin/linkhub", data);
}
